import { computed } from 'vue';
import axios from 'axios';

export function useCorreccion() {
  const API = "https://dash-visaovip.kompara.tech/api";
  const getH = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token_precios") } });

  const esSuperadmin = computed(() => {
    const token = localStorage.getItem("token_precios");
    if (!token) return false;
    try { return JSON.parse(atob(token.split(".")[1])).rol === "superadmin"; }
    catch { return false; }
  });

  const marcarCorreccion = async (codigo) => {
    const motivo = prompt("Motivo de correccion para [" + codigo + "]:", "");
    if (motivo === null) return;
    try {
      await axios.post(API + "/usuarios/superadmin/productos-correccion?codigo=" + codigo + "&motivo=" + encodeURIComponent(motivo), {}, getH());
      alert("Producto [" + codigo + "] marcado para correccion");
    } catch(e) { alert("Error al marcar correccion"); }
  };

  return { esSuperadmin, marcarCorreccion };
}
